import { render, staticRenderFns } from "./_select_league.vue?vue&type=template&id=71a6e5f2&lang=pug&"
import script from "./_select_league.vue?vue&type=script&lang=js&"
export * from "./_select_league.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports